/* Stylesheet */

.nav_container {
  .title {
    padding: 21px 32px 21px 32px;
    margin: 0px 0px 32px 0px;
    color: var(--ion-color-secondary);
  }
}
